var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.88 4.12 13.76 12l-7.88 7.88L8 22l10-10L8 2z"}));
}

Chevron.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Chevron;

Chevron.default = Chevron;
